const GruposRamaisHome = () =>
  import(/* webpackChunkName: "group-pabx-cadastros-grupoatendimento" */ '../_views/GruposRamaisHome')
const CadastroGrupoRamal = () =>
  import(/* webpackChunkName: "group-pabx-cadastros-grupoatendimento" */ '../_views/CadastroGrupoRamal')
const AtualizarGrupoRamal = () =>
  import(/* webpackChunkName: "group-pabx-cadastros-grupoatendimento" */ '../_views/AtualizarGrupoRamal')

import { permissionsPabx } from '../../../../../../utils/permissionsPabx'

export default [
  {
    path: 'gruposramais',
    component: GruposRamaisHome,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'GruposRamais',
  },
  {
    path: 'gruposramais/criar',
    component: CadastroGrupoRamal,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'gruposramais/criar',
  },
  {
    path: 'gruposramais/atualizar/:_id',
    component: AtualizarGrupoRamal,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'gruposramais/atualizar',
    props: true,
  },
]
